import script from "./FeaturesAndAudience.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturesAndAudience.vue?vue&type=script&setup=true&lang=js"

import "./FeaturesAndAudience.vue?vue&type=style&index=0&id=90a301a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a301a2"]])

export default __exports__